import { CheckCircle } from "@mui/icons-material";
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { DLBanner } from "../landing/DLBanner";

export default function Privacy() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  return <Box>
    <Box width={{ xs: "90%", md: "80%" }} m="auto" py={12} maxWidth={1400}>
      <Typography variant="h6" fontWeight={500}>Privacy</Typography>
      <Typography variant={md ? "h1" : "h2"} fontWeight={600}>We're commited to data protection</Typography>
      <Typography mt={4} variant="body1" color="text.secondary" fontWeight={500}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </Typography>
      <Box m="auto" my={8}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={1.5} color="white.main">
            <CheckCircle />
            <Typography mt={4} variant="body1" color="text.secondary" fontWeight={500}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} color="white.main">
            <CheckCircle />
            <Typography mt={4} variant="body1" color="text.secondary" fontWeight={500}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} color="white.main">
            <CheckCircle />
            <Typography mt={4} variant="body1" color="text.secondary" fontWeight={500}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} color="white.main">
            <CheckCircle />
            <Typography mt={4} variant="body1" color="text.secondary" fontWeight={500}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} color="white.main">
            <CheckCircle />
            <Typography mt={4} variant="body1" color="text.secondary" fontWeight={500}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} color="white.main">
            <CheckCircle />
            <Typography mt={4} variant="body1" color="text.secondary" fontWeight={500}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} color="white.main">
            <CheckCircle />
            <Typography mt={4} variant="body1" color="text.secondary" fontWeight={500}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} color="white.main">
            <CheckCircle />
            <Typography mt={4} variant="body1" color="text.secondary" fontWeight={500}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Box>
    <DLBanner />
  </Box>
} 